import { render } from "./ABtn.vue?vue&type=template&id=16d752d6&scoped=true"
import script from "./ABtn.vue?vue&type=script&lang=js"
export * from "./ABtn.vue?vue&type=script&lang=js"

import "./ABtn.vue?vue&type=style&index=0&id=16d752d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d752d6"]])

export default __exports__